<app-header></app-header>
<app-navbar [selected]="'taxes'"></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [subItems]="subLinks" [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <!-- Filtro de tipo de modelo de tasa -->
        <div class="row" [formGroup]="filterParams">
            <div class="modelinput col-4">
                <label>{{ 'model.taxType' | translate }}</label>
                <select class="form-select" aria-label="taxModel" formControlName="taxModel">
                    <option [value]="" hidden></option>
                    <option *ngFor="let model of this.modelResponse.listRateModelDto" [value]="model.idRateModel">
                        {{ (('administrativeTaxes.' + model.typology) | translate) + ' - '
                        +
                        model.rateModelTraductionDto?.[0]?.shortDescription + ' - ' +
                        model.codeRateModel }}
                    </option>
                </select>
            </div>
        </div>

        <!-- Tabla de tasas administrativas -->
        <div *ngIf="filterParams.get('taxModel')?.value" class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{ 'administrativeTaxes.administrativeTaxes' |
                    translate }}</h2>
                <button type="button" class="btn custombutton" (click)="newModel()">
                    {{ 'buttons.newRegister' | translate }}
                </button>
            </div>
        </div>
        <div *ngIf="hasOwnAdministrativeFee">
            <fieldset>
                <table id="table1" class="table">
                    <thead>
                        <tr>
                            <th scope="col" aria-label="check">
                                <span class="visually-hidden">{{'seleccionar' | translate}}</span>
                            </th>
                            <th scope="col">{{ 'administrativeTaxes.catalogCode' | translate }}</th>
                            <th scope="col">{{ 'administrativeTaxes.administrativeTaxe' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of this.ownAdministrativeFeeResponse.listOwnAdministrativeFeeDto"
                            [ngClass]="{ 'resaltado': selectedRowId === row.idOwnAdministrativeFee }">
                            <td>
                                <input [ariaLabel]="row.idOwnAdministrativeFee" type="radio" name="checkbox1"
                                    [checked]="selectedRowId === row.idOwnAdministrativeFee" (click)="toggleRow(row)" />
                                <label [for]="'radio-' + row.idOwnAdministrativeFee" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'administrativeTaxes.catalogCode' | translate }} {{
                                    row.administrativeFeeCatalogDto?.codeAdministrativeFeeCatalog }},
                                    {{ 'administrativeTaxes.administrativeTaxe' | translate }}
                                    <ng-container
                                        *ngFor="let administrative of row.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto">
                                        <span *ngIf="administrative.languageDto?.code === currentLanguage">{{
                                            administrative.description }}</span>
                                    </ng-container>
                                </label>
                            </td>
                            <td>{{ row.administrativeFeeCatalogDto?.codeAdministrativeFeeCatalog }}</td>
                            <td>@for (administrative of
                                row.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto; track $index) {
                                <span *ngIf="administrative.languageDto?.code==currentLanguage">{{
                                    administrative.description }}</span>
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
            <!-- Controles de paginación -->
            <div class="mt-2" *ngIf="this.ownAdministrativeFeeResponse.pageDto">
                <app-paginator [isStart]="this.ownAdministrativeFeeResponse.pageDto.start"
                    [isEnd]="this.ownAdministrativeFeeResponse.pageDto.end"
                    [currentPage]="this.ownAdministrativeFeeResponse.pageDto.currentPage"
                    [totalPages]="this.ownAdministrativeFeeResponse.pageDto.pages"
                    [numberRecord]="this.ownAdministrativeFeeResponse.pageDto.records"
                    [sizePage]="this.ownAdministrativeFeeResponse.pageDto.pageSize">
                </app-paginator>
            </div>

        </div>

        <!-- Formulario de tasas administrativas -->
        <div *ngIf="selectedRowId || isCreate">
            <div>
                <div class="separator mt-5"></div>
                <h2 class="mb-3 mt-4 textformat">{{
                    'administrativeTaxes.administrativeTaxDetails' | translate }}</h2>
            </div>
            <form [formGroup]="ownAdministrativeFeeForm">
                <div class="row">
                    <div class="col-8">
                        <label for="codeOwnAdministrativeFeeCatalog">{{ 'administrativeTaxes.catalogCode' | translate
                            }}<span>
                                *</span></label>
                        <select class="form-select" formControlName="codeOwnAdministrativeFeeCatalog"
                            id="codeOwnAdministrativeFeeCatalog" name="codeOwnAdministrativeFeeCatalog"
                            (change)="onChangeCatalog()">
                            <option [value]="" hidden>{{ 'administrativeTaxes.selectCatalogCode' | translate }}</option>
                            <option *ngFor="let catalog of this.listCatalog"
                                [value]="catalog.codeAdministrativeFeeCatalog">
                                {{ catalog.codeAdministrativeFeeCatalog }} - <span
                                    *ngIf="catalog && catalog.administrativeFeeCatalogTraductionDto && catalog.administrativeFeeCatalogTraductionDto.length>0">{{
                                    catalog.administrativeFeeCatalogTraductionDto[0].description || '' }}</span>
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 modelinput-flex">
                        <label for="descriptionCat">{{ 'administrativeTaxes.catDescription' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control isDisabled" name="descriptionCat" id="descriptionCat"
                            placeholder="Ingrese la descripción en catalán" formControlName="descriptionCat" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 modelinput-flex">
                        <label for="descriptionCast">{{ 'administrativeTaxes.castDescription' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control isDisabled" name="descriptionCast" id="descriptionCast"
                            placeholder="Ingrese la descripción en castellano" formControlName="descriptionCast" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 modelinput-flex">
                        <label for="descriptionIng">{{ 'administrativeTaxes.engDescription' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control isDisabled" name="descriptionIng" id="descriptionIng"
                            placeholder="Ingrese la descripción en inglés" formControlName="descriptionIng" />
                    </div>
                </div>
                <div class="row d-flex">
                    <div class="col-12 mt-4">
                        <button type="button" class="btn cancelbutton me-2" (click)="onCancel()">Cancelar</button>
                        @if(isCreate){
                        <button type="button" class="btn custombutton" (click)="saveOwnAdministrativeFee()">
                            {{ !isCreate ? ('buttons.modify' | translate) : ('buttons.save' | translate) }}
                        </button>
                        }
                    </div>
                </div>
            </form>
        </div>
        <app-alert-component [isOk]="isCreated" [isDanger]="isError" [message]="errorMessage"
            (close)="this.isCreated = isError = false"></app-alert-component>
        <!-- Tabla de precios -->
        <div *ngIf="selectedRowId">
            <div>
                <div class="separator mt-4"></div>
                <div class="row mt-4 mb-3">
                    <h2 class="mb-3 textformat col-8">{{ 'administrativeTaxes.prices' |
                        translate }}</h2>

                    <div class="text-end d-flex align-items-center col-4 mt-2 justify-content-end">
                        <button type="button" class="btn custombutton " id="clone" (click)="clone()"
                            [disabled]="!selectedPricesRowId">{{'Clonar' | translate }}</button>
                        <button type="button" class="btn custombutton ms-2" (click)="newRegister()">
                            {{ 'buttons.newRegister' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <fieldset>
                <table id="table1" class="table">
                    <thead>
                        <tr>
                            <th scope="col">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'administrativeTaxes.price' | translate }}</th>
                            <th scope="col">{{ 'administrativeTaxes.vatPattern' | translate }}</th>
                            <th scope="col">{{ 'administrativeTaxes.optionalFee' | translate }}</th>
                            <th scope="col">{{ 'administrativeTaxes.startDate' | translate }}</th>
                            <th scope="col">{{ 'administrativeTaxes.endDate' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [ngClass]="{'resaltado': selectedPricesRowId === row.idOwnAdministrativeFeeDetail}"
                            *ngFor="let row of this.ownAdministrativeFeeDetailResponse.listOwnAdministrativeFeeDetailDto">
                            <td> <input [ariaLabel]="row.idOwnAdministrativeFeeDetail" type="radio" name="checkbox2"
                                    [checked]="selectedPricesRowId === row.idOwnAdministrativeFeeDetail"
                                    (click)="toggleRowPrices(row)" />
                                <label [for]="'radio-' + row.idOwnAdministrativeFeeDetail" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'administrativeTaxes.price' | translate }} {{ row.price }},
                                    {{ 'administrativeTaxes.vatPattern' | translate }} {{
                                    row.vatPatternDto?.codePatternVat
                                    || 'N/A' }},
                                    {{ 'administrativeTaxes.optionalFee' | translate }} {{ row.optionalFeeIndicator ===
                                    'S'
                                    ? ('administrativeTaxes.S' | translate) : ('administrativeTaxes.N' | translate) }},
                                    {{ 'administrativeTaxes.startDate' | translate }} {{ row.startDate |
                                    date:'dd/MM/yyyy'
                                    }},
                                    {{ 'administrativeTaxes.endDate' | translate }} {{ row.endDate | date:'dd/MM/yyyy'
                                    }}
                                </label>
                            </td>
                            <td>{{ row.price }}</td>
                            <td>{{ row.vatPatternDto?.codePatternVat }}</td>
                            <td>{{ row.optionalFeeIndicator == 'S' ? ('administrativeTaxes.S' | translate) :
                                ('administrativeTaxes.N' | translate) }}</td>
                            <td>{{ row.startDate | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ row.endDate | date: 'dd/MM/yyyy' }}</td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
            <!-- Controles de paginación -->
            <div class="mt-2" *ngIf="this.ownAdministrativeFeeDetailResponse.pageDto">
                <app-paginator [isStart]="this.ownAdministrativeFeeDetailResponse.pageDto.start"
                    [isEnd]="this.ownAdministrativeFeeDetailResponse.pageDto.end"
                    [currentPage]="this.ownAdministrativeFeeDetailResponse.pageDto.currentPage"
                    [totalPages]="this.ownAdministrativeFeeDetailResponse.pageDto.pages"
                    [numberRecord]="this.ownAdministrativeFeeDetailResponse.pageDto.records"
                    [sizePage]="this.ownAdministrativeFeeDetailResponse.pageDto.pageSize">
                </app-paginator>
            </div>

            <div *ngIf="selectedPricesRowId || isCreatePrices || isClone">
                <div>
                    <div class="separator mt-5"></div>
                    <h2 class="mb-3 mt-4 textformat">{{ 'administrativeTaxes.prices' |
                        translate }}</h2>
                </div>
                <form [formGroup]="ownAdministrativeFeeFormPrice">
                    <div class="row">
                        <!-- Fecha de alta -->
                        <div class="mb-3 col-6 ">
                            <label for="startDate" class="form-label">
                                {{ 'administrativeTaxes.startDate' | translate }}<span>
                                    *</span>
                            </label>
                            <input type="date" class="form-control" id="startDate" name="startDate"
                                formControlName="startDate" />
                        </div>

                        <!-- Fecha de baja -->
                        <div class="mb-3 col-6 ">
                            <label for="endDate" class="form-label">
                                {{ 'administrativeTaxes.endDate' | translate }}
                            </label>
                            <input type="date" class="form-control" id="endDate" name="endDate"
                                formControlName="endDate" />
                        </div>
                    </div>

                    <div class="row">
                        <!-- Precio -->
                        <div class="mb-3 col-6 ">
                            <label for="price" class="form-label">
                                {{ 'administrativeTaxes.price' | translate }}<span>
                                    *</span>
                            </label>
                            <input type="number" class="form-control" id="price" name="price" formControlName="price"
                                [min]="0" />
                        </div>

                        <!-- Patrón de IVA -->
                        <div class="mb-3 col-6 ">
                            <label for="idVatPattern" class="form-label">
                                {{ 'administrativeTaxes.vatPattern' | translate }}<span>
                                    *</span>
                            </label>
                            <select class="form-select" id="idVatPattern" name="idVatPattern"
                                formControlName="idVatPattern">
                                <option *ngFor="let vat of this.vatPatternResponse.listVatPatternDto"
                                    [value]="vat.idVatPattern">
                                    {{ vat.vatPatternTraductionDto?.[0]?.description }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Precio -->
                        <div class="mb-3 col-6 ">
                            <label for="ageLimit" class="form-label">
                                {{ 'administrativeTaxes.ageLimit' | translate }}<span>
                                    *</span>
                            </label>
                            <input type="number" class="form-control" id="ageLimit" name="ageLimit"
                                formControlName="ageLimit" [min]="0" />
                        </div>
                        <div class="mt-4 col-6 ">
                            <input class="form-check-input mx-3" type="checkbox" id="ageControlIndicator"
                                name="ageControlIndicator" formControlName="ageControlIndicator">
                            <label class="form-label" for="ageControlIndicator">
                                {{ 'administrativeTaxes.ageControl' | translate }}
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Precio -->
                        <div class="mt-4 col-6 ">
                            <input class="form-check-input mx-3" type="checkbox" id="optionalFeeIndicator"
                                name="optionalFeeIndicator" formControlName="optionalFeeIndicator">
                            <label class="form-label" for="optionalFeeIndicator">
                                {{ 'administrativeTaxes.optionalFee' | translate }}
                            </label>
                        </div>
                        <div class="mt-4 col-6 ">
                            <input class="form-check-input mx-3" type="checkbox" id="firstPaymentIndicator"
                                name="firstPaymentIndicator" formControlName="firstPaymentIndicator">
                            <label class="form-label" for="firstPaymentIndicator">
                                {{ 'administrativeTaxes.firstPayment' | translate }}
                            </label>
                        </div>

                    </div>
                </form>
                <div class="row d-flex">
                    <div class="col-12 mt-4">
                        <button type="button" class="btn cancelbutton"
                            (click)="selectedPricesRowId = null; isClone = isCreatePrices = false">
                            {{ 'administrativeTaxes.cancel' | translate }}
                        </button>
                        <button type="button" class="btn custombutton ms-2" (click)="savePriceRecord()">
                            {{ (selectedPricesRowId && !isClone) ? ('academicTaxes.modify' | translate ) :
                            'academicTaxes.save' |
                            translate}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <app-alert-component [isOk]="isCreatedPrice" [isDanger]="isErrorPrice" [message]="errorMessage"
            (close)="this.isCreatedPrice = isErrorPrice = false"></app-alert-component>
        <div *ngIf="selectedRowId">
            <div>
                <div class="separator mt-4"></div>
                <div class="row mt-4 mb-3">
                    <h2 class="mb-3 textformat col-8"> {{'navbar.discounts' | translate}}
                    </h2>
                    <div class="text-end d-flex align-items-center col-4 mt-2 justify-content-end">
                        <button type="button" class="btn custombutton"
                            (click)="newAcademicDiscount()">{{'academicTaxes.newRegister' | translate}}</button>
                    </div>
                </div>
            </div>

            <div>
                <fieldset>
                    <table id="table2" class="table">
                        <thead>
                            <tr>
                                <th scope="col" aria-label="check">
                                    <span class="visually-hidden">{{'seleccionar' | translate}}</span>
                                </th>
                                <th scope="col">{{'discount.codeDiscount' | translate}}</th>
                                <th scope="col">{{'academicTaxes.discount' | translate}}</th>
                                <th scope="col">{{'%'}}</th>
                                <th scope="col">{{'academicTaxes.import' | translate}}</th>
                                <th scope="col">{{'academicTaxes.order' | translate}}</th>
                                <th scope="col">{{'academicTaxes.registrationDate' | translate}}</th>
                                <th scope="col">{{'academicTaxes.endDate' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr *ngFor="let row of this.ownRateDiscountResponse.IdOwnRateDiscountDto; let id=index"
                                [ngClass]="{ 'resaltado': selectedOwnRateDiscountId === row.idOwnRateDiscount}">
                                <td>
                                    <input [ariaLabel]="row.idOwnRateDiscount" type="radio" name="checkbox3"
                                        [checked]="selectedOwnRateDiscountId === row.idOwnRateDiscount"
                                        (click)="toggleRowAcademicDiscount(row)" />
                                    <label [for]="'radio-' + row.idOwnRateDiscount" class="visually-hidden">
                                        {{ "seleccionarFilaCon" | translate }}:
                                        {{ 'discount.codeDiscount' | translate }} {{
                                        row.generalDiscountCatalogDto?.discountCode }},
                                        {{ 'academicTaxes.discount' | translate }}
                                        <ng-container
                                            *ngFor="let desc of row.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto">
                                            <span *ngIf="desc.languageDto?.code === currentLanguage">{{
                                                desc.discountDescription }}</span>
                                        </ng-container>,
                                        {{ '%' }} {{ row.discountPercentage }},
                                        {{ 'academicTaxes.import' | translate }} {{ row.fixedDiscountAmount }},
                                        {{ 'academicTaxes.order' | translate }} {{ row.discountOrderNumber }},
                                        {{ 'academicTaxes.registrationDate' | translate }} {{ row.startDate |
                                        date:'dd/MM/yyyy' }},
                                        {{ 'academicTaxes.endDate' | translate }} {{ row.endDate | date:'dd/MM/yyyy' }}
                                    </label>
                                </td>
                                <td>{{ row.generalDiscountCatalogDto?.discountCode }}</td>
                                <td>@for (desc of row.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto;
                                    track
                                    $index) {
                                    <span
                                        *ngIf="desc.languageDto?.code==currentLanguage">{{desc.discountDescription}}</span>
                                    }
                                </td>
                                <td>{{ row.discountPercentage }}</td>
                                <td>{{ row.fixedDiscountAmount}}</td>
                                <td>{{ row.discountOrderNumber }}</td>
                                <td>{{ row.startDate | date:'dd/MM/yyyy' }}</td>
                                <td>{{ row.endDate | date:'dd/MM/yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>
                <!-- Controles de paginación -->
                <div class="mt-2" *ngIf="this.ownRateDiscountResponse.pageDto">
                    <app-paginator [isStart]="this.ownRateDiscountResponse.pageDto.start"
                        [isEnd]="this.ownRateDiscountResponse.pageDto.end"
                        [currentPage]="this.ownRateDiscountResponse.pageDto.currentPage"
                        [totalPages]="this.ownRateDiscountResponse.pageDto.pages"
                        [numberRecord]="this.ownRateDiscountResponse.pageDto.records"
                        [sizePage]="this.ownRateDiscountResponse.pageDto.pageSize">
                    </app-paginator>
                </div>

                <div *ngIf="selectedOwnRateDiscountId || isCreatedOwnRateDiscount">
                    <div>
                        <div class="separator mt-5"></div>
                        <h2 class="mb-3 mt-4 textformat"> {{'navbar.discounts' |
                            translate}}</h2>
                    </div>
                    <form [formGroup]="formDiscount">
                        <div class="row">
                            <div class="mb-3 col-6 ">
                                <label for="idGeneralDiscountCatalog" class="form-label">{{'academicTaxes.discount'
                                    |translate}}<span>
                                        *</span></label>
                                <select class="form-select" formControlName="idGeneralDiscountCatalog"
                                    id="idGeneralDiscountCatalog" name="idGeneralDiscountCatalog"
                                    (change)="changeDescompte()">
                                         @for (discount of this.discountRateModelResponse.discountRateModelCatalogDto; track $index) {
                                        @if(isDiscountValid(discount.generalDiscountCatalogDto?.discountCode) || !isCreatedOwnRateDiscount) {
                                    <option
                                        [value]="discount.discountRateModelCatalogPkDto?.generalDiscountCatalogId">
                                        <span>{{discount.generalDiscountCatalogDto?.discountCode}} - <span>{{
                                                getDiscountDescription(discount.generalDiscountCatalogDto?.idGeneralDiscountCatalog)
                                                }}</span>
                                        </span>
                                    </option>
                                }
                                }
                                </select>
                            </div>
                            <div class="mb-3 col-6">
                                <label for="discountOrderNumber" class="form-label">{{'academicTaxes.order' |
                                    translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="discountOrderNumber"
                                    name="discountOrderNumber" formControlName="discountOrderNumber" />
                                <span *ngIf="message.length>0">{{'messageOrder' | translate}}
                                    <strong>{{message[0].generalDiscountCatalogDto.discountCode}}</strong> </span>
                            </div>
                            <div class="mb-3 col-6">
                                <label for="importType" class="form-label">{{'typesVat.type' |translate}}</label>
                                <select class="form-select" formControlName="importType" name="importType"
                                    id="importType">
                                    <option value="I">{{'academicTaxes.import' |translate}}</option>
                                    <option value="P">{{'typesVat.percentage' |translate}}</option>
                                </select>
                            </div>
                            @if (formDiscount.get('importType')?.value=='I') {
                            <div class="mb-3 col-6">
                                <label for="fixedDiscountAmount" class="form-label">{{'academicTaxes.import'
                                    |translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="fixedDiscountAmount"
                                    name="fixedDiscountAmount" formControlName="fixedDiscountAmount" [min]="0" />
                            </div>
                            }
                            @if (formDiscount.get('importType')?.value=='P') {
                            <div class="mb-3 col-6">
                                <label for="discountPercentage" class="form-label">{{'typesVat.percentage'|
                                    translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="discountPercentage"
                                    name="discountPercentage" formControlName="discountPercentage" [min]="0"
                                    [max]="100" />
                            </div>
                            }
                            <div class="mb-3 col-6">
                                <label for="startDate1" class="form-label">{{'academicTaxes.registrationDate' |
                                    translate}}<span>
                                        *</span></label>
                                <input type="date" class="form-control" id="startDate1" name="startDate1"
                                    formControlName="startDate" />
                            </div>

                            <!-- Fecha de baja -->
                            <div class="mb-3 col-6">
                                <label for="endDate1" class="form-label">{{'academicTaxes.endDate'
                                    |translate}}</label>
                                <input type="date" class="form-control" id="endDate1" name="endDate1"
                                    formControlName="endDate" />
                            </div>
                        </div>
                        <div class="row d-flex">
                            <div class="col-12 mt-4">
                                <button type="button" class="btn cancelbutton"
                                    (click)="selectedOwnRateDiscountId = null; this.formDiscount.reset(); this.isCreatedOwnRateDiscount = false">{{'academicTaxes.cancel'
                                    |translate}}</button>
                                <button *ngIf="!selectedOwnRateDiscountId" type="button" class="btn custombutton ms-2"
                                    (click)="saveOwnRateDiscount()"> {{
                                    'academicTaxes.save' | translate
                                    }}</button>
                                <button *ngIf="selectedOwnRateDiscountId" type="button" class="btn custombutton ms-2"
                                    (click)="saveOwnRateDiscount()"> {{
                                    'academicTaxes.modify' | translate
                                    }}</button>
                            </div>
                        </div>

                    </form>
                </div>
                <app-alert-component [isDanger]="isErrorOwnRateDiscount" [isOk]="isCreateOwnRateDiscount"
                    [message]="errorMessage"
                    (close)="this.isCreateOwnRateDiscount = this.isErrorOwnRateDiscount = false"></app-alert-component>
            </div>
        </div>
    </main>
</div>